import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class ApiUrlService {
  private readonly document = inject(DOCUMENT);
  private readonly baseUrl = this.resolveBaseUrl();

  build(path: string): string {
    if (!this.baseUrl) {
      return path;
    }
    const normalizedBase = this.baseUrl.replace(/\/$/, '');
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${normalizedBase}${normalizedPath}`;
  }

  private resolveBaseUrl(): string {
    if (typeof window === 'undefined') {
      return '';
    }
    const windowBase = (window as { __API_BASE_URL?: string }).__API_BASE_URL;
    if (typeof windowBase === 'string' && windowBase.trim().length > 0) {
      return windowBase.trim();
    }
    const meta = this.document.querySelector('meta[name="api-base-url"]');
    const metaValue = meta?.getAttribute('content');
    return metaValue ? metaValue.trim() : '';
  }
}
